/* __next_internal_client_entry_do_not_use__ default auto */ import * as React from 'react';
/**
 * @ignore - internal component.
 */ const ToggleButtonGroupContext = /*#__PURE__*/ React.createContext({});
if ("production" !== 'production') {
    ToggleButtonGroupContext.displayName = 'ToggleButtonGroupContext';
}
export default ToggleButtonGroupContext;
